/**
 * Product branding — single source of truth for the product name, the logo
 * asset and the login hero copy. Every React surface (app shell, auth pages,
 * docs) reads from here.
 */
export const BRAND = {
  /** Display name. */
  name: 'Nord Living',
  /** Studio descriptor printed under the wordmark. */
  descriptor: 'Interior Design Studio',
  /** Wordmark asset (brown on transparent), served from `public/`. */
  logoSrc: '/brand/nord-living-logo.png',
  /** Login hero headline (LoginHeroSection). */
  tagline: 'Clients, projects & payments',
  /** Login hero sub-copy under the tagline. */
  loginSubtitle:
    'Sign in to run every project, invoice, purchase and reimbursement in one place.',
  /** Login hero trust badge. */
  loginBadge: 'Nord Living · Interior Design Studio',
} as const;
